<template>
	<div class="act-container">
		<CFullEmpty v-if="emptyData" class="empty-box" />
		<template v-else>
			<div v-for="(item, index) in tabData" :key="index" class="activity-item" @click="viewRoadShowDetail(item)">
				<div class="roadshow-left-area">
					<div class="roadshow-header">
						<span class="roadshow-status status-notice" v-if="item.status == 0">
							<svg class="icon-svg" aria-hidden="true"><use xlink:href="#icon-yugao"></use></svg>
							{{ $t('enterprise.investment.preview') }}
						</span>
						<span class="roadshow-status status-live" v-if="item.status == 1">
							<span class="icon-live"></span>{{ $t('enterprise.investment.live') }}
						</span>
						<span class="roadshow-status status-playback" v-if="item.status == 3">
							<svg class="icon-svg" aria-hidden="true"><use xlink:href="#icon-huifang"></use></svg>
							{{ $t('enterprise.investment.playback') }}
						</span>
						<span class="roadshow-title">{{ item.title }}</span>
					</div>
					<div class="roadshow-footer">
						<p class="organizer-time">
							<span v-if="item.creator" class="roadshow-organizer">{{ item.creator.uname }}</span>
							<span class="roadshow-time">{{ formatIrYear(item.stime || item.ctime) }}</span>
						</p>
						<p class="browse-count" v-if="item.sourceType != 1">
							{{ item.browsecount | computedNumMoreThanTenThousand
							}}{{ $t('enterprise.investment.views') }}
						</p>
					</div>
				</div>
				<div v-if="getRoadshowCover(item)" class="roadshow-main">
					<m-lazy-img :imgType="4" :imgUrl="getRoadshowCover(item)"></m-lazy-img>
					<div
						class="roadshow-authtag"
						v-if="
							!(
								!item.authtag ||
								(isWxMiniProgram && (isTagPay(item.authtag) || isTagAudition(item.authtag)))
							)
						"
					>
						{{
							isWxMiniProgram && (isTagPay(item.authtag) || isTagAudition(item.authtag))
								? ''
								: item.authtag
						}}
					</div>
					<div class="roadshow-icon">
						<svg class="icon-svg" aria-hidden="true"><use xlink:href="#icon-shipintubiao"></use></svg>
					</div>
				</div>
			</div>
		</template>
		<CFooterLoad ref="footerLoadObs" :more="hasMore" @load-more="loadMoreData" />
	</div>
</template>

<script>
import CFooterLoad from '@/view/enterprise/components/c-footer-load.vue';
import CFullEmpty from '@/view/enterprise/components/c-full-empty.vue';
import paginationMixin from '@/view/enterprise/mixins/paginationMixin';
import { formatIrYear, isWxMiniProgram } from '@/utils/api';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useCurrentReactive } from '@rebuild/materials/shared/investment_activity/context';
import { computed } from 'vue';

export default {
	components: {
		CFooterLoad,
		CFullEmpty
	},
	mixins: [paginationMixin],
	data() {
		return {};
	},
	mounted() {
		// install mixins
		this.PAGINATION_LOAD = this.loadModule;
		this.PAGINATION_OBS_INSTALL = () => {
			this.$refs.footerLoadObs && this.$refs.footerLoadObs.install();
		};
		this.PAGINATION_OBS_UNINSTALL = () => {
			this.$refs.footerLoadObs && this.$refs.footerLoadObs.uninstall();
		};
	},
	methods: {
		loadMoreData() {
			this.PAGINATION_LOAD_MORE();
		},
		refreshModule(query) {
			this.PAGINATION_REFRESH();
		},
		async loadModule() {
			try {
				await this.loadRoadshow({
					pageStart: this.pageStart,
					pageNum: 20
				});
				const data = this.getRoadshowData;
				const newData = data?.data || [];

				this.PAGINATION_DATA_UPDATE(newData);
				this.$emit('refresh');
				const total = data?.total || 0;
				const hasMore = this.tabData.length < total;
				return Promise.resolve(hasMore);
			} catch (error) {
				return Promise.resolve(false);
			}
		},
		handleReport(item) {
			this.viewModule('report', item);
		}
	},
	setup() {
		const isTagPay = v => v === '付费' || v === '付費' || v === 'Pay';
		const isTagAudition = v => v === '试听' || v === '試聽' || v === 'Audition';

		const { viewInRoadshow } = useCurrentReactive();
		const viewRoadShowDetail = item => viewInRoadshow(item);

		const getRoadshowCover = item => item.logo43;

		const { roadshow } = useModuleData();
		const loadRoadshow = (query = {}) => roadshow.refresh(query);
		const getRoadshowData = computed(() => roadshow.data);

		return {
			isTagPay,
			isTagAudition,
			viewRoadShowDetail,
			getRoadshowCover,

			loadRoadshow,
			getRoadshowData,

			formatIrYear,
			isWxMiniProgram
		};
	}
};
</script>

<style lang="less" scoped>
@import '@/style/mixins';
@import '@/style/mixin/text-overflow.less';

.act-container {
	background: #fff;
	padding: 0 0.12rem;
}
.activity-empty {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}

.activity-item {
	display: flex;
	align-items: top;
	justify-content: flex-start;
	padding-bottom: 0.14rem;
	margin-bottom: 0.14rem;
	background: #fff;
	.thinner-border-bottom(#e8eaef);
	&:first-child {
		padding-top: 0.14rem;
	}
	.roadshow-left-area {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		flex: 1;
		width: 0;
	}
	.roadshow-header {
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 500;
		font-size: 0.15rem;
		line-height: 140%;
		color: #333333;
		.text-overflow-multi-row(2);
	}
	.roadshow-status {
		margin-right: 0.04rem;
		height: 0.16rem;
		padding: 0 0.04rem;
		display: inline-flex;
		align-items: center;
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 0.11rem;
		line-height: 0.16rem;
		.icon-live {
			width: 0.12rem;
			height: 0.12rem;
			margin-right: 0.03rem;
			background: url('@/assets/images/irstore/irstore_playing.gif') no-repeat;
			background-size: 100% 100%;
		}
		.icon-svg {
			margin-right: 0.03rem;
		}
	}
	.status-notice {
		background-color: rgba(80, 130, 240, 0.1);
		color: #5082f0;
	}
	.status-live {
		background-color: rgba(252, 77, 57, 0.1);
		color: #fa4646;
	}
	.status-playback {
		background-color: rgba(93, 102, 122, 0.1);
		color: #5d667a;
	}
	.roadshow-title {
		max-height: 64px;
		.text-overflow-multi-row();
		display: inline;
	}
	.roadshow-main {
		position: relative;
		margin-left: 0.08rem;
		width: 1.08rem;
		height: 0.81rem;
		border-radius: 0.02rem;
		overflow: hidden;
		flex-shrink: 0;
		.roadshow-authtag {
			position: absolute;
			top: 0.04rem;
			right: 0.04rem;
			height: 0.16rem;
			padding: 0 0.05rem;
			background: #ff7d4a;
			color: #ffffff;
			font-size: 0.1rem;
			text-align: center;
			line-height: 0.15rem;
		}
	}
	.roadshow-image {
		width: 100%;
		height: 100%;
		border-radius: 0.04rem;
	}
	.roadshow-icon {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 0.4rem;
		height: 0.4rem;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		.icon-svg {
			width: 100%;
			height: 100%;
		}
	}
	.roadshow-footer {
		padding: 0.08rem 0 0;
		display: flex;
		justify-content: space-between;
		font-family: 'PingFang SC';
		color: #999999;
	}
	.organizer-time {
		font-size: 0;
	}
	.roadshow-organizer {
		margin-right: 0.12rem;
		display: inline-block;
		line-height: 0.17rem;
		font-size: 0.12rem;
	}
	.roadshow-time {
		display: inline-block;
		line-height: 0.17rem;
		font-size: 0.12rem;
	}
	.browse-count {
		line-height: 0.17rem;
		font-size: 0.12rem;
	}
}
</style>
